import { toNewsItem, toNewsItemList } from "~/transformers/newsTransformer";

export default {
  async fetch({ dispatch, commit }, requestParams = {}) {
    commit("SET_LOADING", true);
    try {
      await dispatch("setNewsItems", requestParams);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  setLoading({ commit }, loading) {
    commit("SET_LOADING", loading);
  },

  async setNewsItems({ commit, rootGetters, state }, params = {}) {
    const { filter } = params;
    const size = rootGetters["application/getPageSize"];
    const { page } = state.paginator;
    const { field: sortBy, order: orderBy } = state.sort;
    try {
      const response = await this.$services.news.fetch({ size, page, sortBy, orderBy, filter });
      commit("SET_NEWS_ITEMS", { ...response, collection: toNewsItemList(response.collection) });
      commit("SET_PAGINATOR", { page: response.page, size: response.size, total: response.total });
      commit("SET_PAGINATOR_LOADING_PAGE", null);
    } catch (error) {
      throw new Error(error);
    }
  },

  updatePage({ commit }, page) {
    commit("SET_PAGINATOR_LOADING_PAGE", page);
    commit("SET_PAGINATOR_PAGE", page);
  },

  changeSort({ commit }, { field, order }) {
    commit("SET_SORT", { field, order });
  },

  async changeSizeTable({ commit, dispatch }, { size }) {
    await dispatch("application/savePageSize", size, { root: true });
    commit("SET_PAGINATOR_PAGE", 0);
    commit("SET_PAGINATOR_LOADING_PAGE", 0);
  },

  async addNewsItem({ commit }, newsItem) {
    try {
      const createdNewsItem = await this.$services.news.create(newsItem);
      commit("ADD_NEWS_ITEM", toNewsItem(createdNewsItem));
      this.$feedback.ok("feedback.create.news.ok");
    } catch (error) {
      const { error: prefix, message } = error.response.data;
      this.$feedback.error(`${prefix}${message}`);
    }
  },

  async setNewsItem({ commit }, { savedNewsItem, id }) {
    const { headline, body } = savedNewsItem;
    try {
      const newsItem = await this.$services.news.patch(id, { id, headline, body });
      commit("SET_NEWS_ITEM", toNewsItem(newsItem));
      this.$feedback.ok("feedback.update.news.ok");
    } catch {
      this.$feedback.error("feedback.update.news.error");
    }
  },

  async deleteNewsItem({ commit }, id) {
    try {
      await this.$services.news.remove(id);
      commit("DELETE_NEWS_ITEM", id);
      this.$feedback.ok("feedback.delete.news.ok");
    } catch {
      this.$feedback.error("feedback.delete.news.error");
    }
  },

  async fetchNewsItem({ commit }, id) {
    try {
      const editingNewsItem = await this.$services.news.fetchOne(id);
      commit("SET_EDITING_NEWS_ITEM", toNewsItem(editingNewsItem));
    } catch (error) {
      throw new Error(error);
    }
  },
};
